import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";

class PageAlert extends React.PureComponent {
  static get propTypes() {
    return {
      children: PropTypes.node,
    };
  }

  render() {
    return (
      <Alert className="alert-muted small-alert">
        <i className="fa fa-info-circle" aria-hidden="true" />
        <span className="font-smaller">{this.props.children}</span>
      </Alert>
    );
  }
}

export { PageAlert };
